var map = {
	"./icon-admin.svg": "8bed",
	"./icon-bianji.svg": "5e9c",
	"./icon-config.svg": "5035",
	"./icon-dangdifill.svg": "4cd8",
	"./icon-daohang.svg": "b2aa",
	"./icon-duanxin.svg": "132e",
	"./icon-editor.svg": "a7be",
	"./icon-geren.svg": "7e67",
	"./icon-jiesuo.svg": "c4b9",
	"./icon-job.svg": "ba97",
	"./icon-log.svg": "5d30",
	"./icon-menu.svg": "08c6",
	"./icon-mudedi.svg": "a48f",
	"./icon-oss.svg": "50f6",
	"./icon-pinglun.svg": "8118",
	"./icon-role.svg": "7a1a",
	"./icon-shanchu.svg": "80de",
	"./icon-shezhi.svg": "c3a0",
	"./icon-shoucang.svg": "1d97",
	"./icon-shoucangfill.svg": "cc0f",
	"./icon-shouye.svg": "5f57",
	"./icon-sousuo.svg": "f320",
	"./icon-sql.svg": "955e",
	"./icon-suoding.svg": "5ac1",
	"./icon-system.svg": "fe99",
	"./icon-tixing.svg": "4b03",
	"./icon-tubiao.svg": "d1e0",
	"./icon-xiangqu.svg": "c3f4",
	"./icon-xiangqufill.svg": "131f",
	"./icon-zhedie.svg": "d8f2",
	"./icon-zonghe.svg": "9bd1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51b3";